import { CURRENCY_OPTIONS, type CurrencyCode } from "@/lib/currency";
import { useCurrency } from "@/hooks/use-currency";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

type CurrencySelectorProps = {
  className?: string;
  label?: string;
};

export function CurrencySelector({ className, label = "Prices shown in" }: CurrencySelectorProps) {
  const { currency, setCurrency, ratesUpdatedAt, usingLiveRates } = useCurrency();
  const lastUpdatedLabel = ratesUpdatedAt ? new Date(ratesUpdatedAt).toLocaleString() : "Using default rates";

  return (
    <div className={`flex items-center gap-2 text-xs text-muted-foreground ${className || ""}`}>
      <span>{label}</span>
      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value as CurrencyCode)}
        className="rounded-md border border-border/50 bg-background/70 px-2 py-1 text-xs text-foreground"
        aria-label="Currency"
      >
        {CURRENCY_OPTIONS.map((option) => (
          <option key={option.code} value={option.code}>
            {option.label}
          </option>
        ))}
      </select>
      <span className="text-muted-foreground/80 flex items-center gap-1">
        Billed in AUD
        <Tooltip>
          <TooltipTrigger asChild>
            <Info className="h-3.5 w-3.5 text-muted-foreground/70" />
          </TooltipTrigger>
          <TooltipContent>
            <p>Converted estimates. Checkout is charged in AUD.</p>
            <p className="text-xs text-muted-foreground mt-1">
              {usingLiveRates ? `Rates updated: ${lastUpdatedLabel}` : lastUpdatedLabel}
            </p>
          </TooltipContent>
        </Tooltip>
      </span>
    </div>
  );
}
